import React from 'react'
import {
  List,
  Filter,
  Datagrid,
  TextField,
  ImageField,
  SearchInput,
  BulkDeleteButton,
  BooleanInput,
  ReferenceField
} from 'react-admin'
import ListPagination from '../../components/ListPagination'
import RequiredChain from '../../components/RequiredChain'

const Filters = props => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <BooleanInput label="Desativados" source="isDisabled" sx={{ height: 36 }} alwaysOn />
  </Filter>
)

const BulkActionButtons = () => (
  <BulkDeleteButton label="Inativar" />
)

const list = ({ ...props }) => {
  return (
    <RequiredChain>
      <List
        {...props}
        perPage={25}
        hasCreate
        pagination={<ListPagination />}
        exporter={false}
        title="Produtos"
        filters={<Filters />}
        filterDefaultValues={{ isDisabled: false }}
      >
        <Datagrid rowClick="edit" bulkActionButtons={<BulkActionButtons />}>
          <ImageField sx={{ '& img': { maxWidth: '4rem' } }} source="imagePath" label="Imagem" />
          <TextField source="name" label="Nome" />
          <TextField source="description" label="Descrição" />
          <ReferenceField
            label="Categoria"
            reference="chains/chainId/product-categories"
            source="categoryId">
            <TextField source="name" />
          </ReferenceField>
        </Datagrid>
      </List>
    </RequiredChain>
  )
}

export default list
